import NextButton from "@/components/created/NextButton.vue";
import BackButton from "@/components/created/BackButton.vue";

export default {
  install(Vue) {
    Vue.component("NextButton", NextButton);
    Vue.component("BackButton", BackButton);
  },
};
